module.exports = __webpack_public_path__ + "img/resumeIcon.b08aca1c.svg";